export default __webpack_public_path__ + "static/media/Expire-Date.23e744fa.svg";